
import { useEffect, useRef, useCallback, useState } from "react";
import * as signalR from "@microsoft/signalr";

export const useSignalR = ({ url, enabled, onMessage }) => {
  const connectionRef = useRef(null);
  const onMessageRef = useRef(onMessage);
  // const isStartingRef = useRef(false);

  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  const sendMessage = useCallback(async (methodName, ...args) => {
    const connection = connectionRef.current;

    // console.log(" SignalR SEND TRY:", {
    //   methodName,
    //   args,
    //   state: connection?.state,
    // });

    if (
      !connection ||
      connection.state !== signalR.HubConnectionState.Connected
    ) {
      console.warn(" SignalR NOT CONNECTED → send skipped");
      return;
    }

    try {
      await connection.invoke(methodName, ...args);
      // console.log("SignalR SEND SUCCESS:", methodName);
    } catch (err) {
      console.error(" SignalR SEND ERROR:", err);
    }
  }, []);

  /* CONNECTION SETUP */
  useEffect(() => {

    if (!enabled) {
      // console.log(" SignalR disabled → skip connect");
      return;
    }

    if (connectionRef.current) {
      // console.log(" SignalR already connected");
      return;
    }

    // console.log(" SignalR STARTING...");

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    /*  EVENTS  */

    connection.on("ReceiveStatusUpdate", (data) => {
      console.log(" SignalR EVENT → ReceiveStatusUpdate:", data);
      onMessageRef.current?.(data);
    });

    connection.onreconnecting((err) => {
      console.warn(" SignalR RECONNECTING...", err);
      setIsConnected(false);
    });

    connection.onreconnected((connectionId) => {
      console.log(" SignalR RECONNECTED:", connectionId);
      setIsConnected(true);
    });

    connection.onclose((err) => {
      console.error(" SignalR CLOSED:", err);
      connectionRef.current = null;
      setIsConnected(false);
    });

    /*  START  */
    connection
      .start()
      .then(() => {
        console.log(" SignalR CONNECTED");
        setIsConnected(true);
      })
      .catch((err) => {
        console.error(" SignalR START ERROR:", err);
      })
      .finally(() => {
        // isStartingRef.current = false;
      });

    connectionRef.current = connection;

    /*  CLEANUP  */
    return () => {
      // console.log(" SignalR CLEANUP");
      if (connectionRef.current) {
        connectionRef.current
          .stop()
          .then(() => console.log(" SignalR STOPPED"))
          .catch((e) => console.error(" SignalR STOP ERROR:", e))
          .finally(() => {
            connectionRef.current = null;
            setIsConnected(false);
          });
      }
    };
  }, [enabled, url]);

  /* STATE WATCH */
  useEffect(() => {
    // console.log(" SignalR STATE CHANGED isConnected:", isConnected);
  }, [isConnected]);

  return {
    sendMessage,
    isConnected,
  };
};


